import { gql } from "graphql-request";

export const editarDocente = gql`
  mutation editarDocente(
    $id: ID
    $carrera: String
    $condicion: String
    $correoInstitucional: String
    $correoSecundario: String
    $identificacion: String
    $nombre: String
    $sede: Boolean
    $telefono: String
    $tipo: Int
    $unidad: String
    $comprobante: Upload
    $universidad: String
    $pais: String
    $tieneDiscapacidad: Boolean
    $tipoDiscapacidad: String
    $requiereApoyo: Boolean
    $detalleApoyo: String
  ) {
    editarDocente(
      id: $id
      carrera: $carrera
      condicion: $condicion
      correoInstitucional: $correoInstitucional
      correoSecundario: $correoSecundario
      identificacion: $identificacion
      nombre: $nombre
      sede: $sede
      telefono: $telefono
      tipo: $tipo
      unidad: $unidad
      comprobante: $comprobante
      universidad: $universidad
      pais: $pais
      tieneDiscapacidad: $tieneDiscapacidad
      tipoDiscapacidad: $tipoDiscapacidad
      requiereApoyo: $requiereApoyo
      detalleApoyo: $detalleApoyo
    ) {
      docente {
        id
        identificacion
        nombre
      }
      success
    }
  }
`;
